// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TicTacToe.css */
/* body {
  background: linear-gradient(to right, #a8edea, #fed6e3);
  font-family: 'Comic Neue', 'Poppins', sans-serif;
} */

.tictoc {
  background: white;
  padding: 20px;
  margin: 50px auto;
  border-radius: 25px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  max-width: 600px;
  text-align: center;
}

.title {
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: #4b0082;
}

.mode-select button,
.difficulty-select button {
  margin: 5px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0,0,0,0.2);
}

.mode-select .active {
  background: #4b0082;
  color: white;
}

.difficulty-select button.easy {
  background: #4caf50;
  color: white;
}

.difficulty-select button.hard {
  background: #e53935;
  color: white;
}

.board {
  display: grid;
  grid-template-columns: repeat(3, 100px);
  gap: 10px;
  justify-content: center;
  margin: 20px auto;
}

.square {
  width: 100px;
  height: 100px;
  font-size: 2.5rem;
  font-weight: bold;
  border-radius: 20px;
  background: #f0f0f0;
  border: 2px solid #ccc;
  transition: transform 0.2s;
  cursor: pointer;
}

.square:hover {
  transform: scale(1.05);
}

.square.x {
  color: #4b0082;
}

.square.o {
  color: #ff3d00;
}

.square.winning {
  background: linear-gradient(145deg, #90ee90, #32cd32);
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.07); }
  100% { transform: scale(1); }
}

.status {
  font-size: 1.3rem;
  margin: 10px 0;
  font-weight: bold;
}

.scores {
  display: flex;
  justify-content: space-around;
  margin: 10px 0;
  font-size: 1.1rem;
}

.controls button {
  padding: 10px 20px;
  border-radius: 20px;
  font-weight: bold;
  border: none;
  margin: 5px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  cursor: pointer;
  transition: all 0.3s ease;
}

.play-again {
  background: #673ab7;
  color: white;
}

.new-game {
  background: #2196f3;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/newtest/game/TicTacToe.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;;;GAGG;;AAEH;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":["/* TicTacToe.css */\n/* body {\n  background: linear-gradient(to right, #a8edea, #fed6e3);\n  font-family: 'Comic Neue', 'Poppins', sans-serif;\n} */\n\n.tictoc {\n  background: white;\n  padding: 20px;\n  margin: 50px auto;\n  border-radius: 25px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.25);\n  max-width: 600px;\n  text-align: center;\n}\n\n.title {\n  font-size: 2.2rem;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #4b0082;\n}\n\n.mode-select button,\n.difficulty-select button {\n  margin: 5px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.2);\n}\n\n.mode-select .active {\n  background: #4b0082;\n  color: white;\n}\n\n.difficulty-select button.easy {\n  background: #4caf50;\n  color: white;\n}\n\n.difficulty-select button.hard {\n  background: #e53935;\n  color: white;\n}\n\n.board {\n  display: grid;\n  grid-template-columns: repeat(3, 100px);\n  gap: 10px;\n  justify-content: center;\n  margin: 20px auto;\n}\n\n.square {\n  width: 100px;\n  height: 100px;\n  font-size: 2.5rem;\n  font-weight: bold;\n  border-radius: 20px;\n  background: #f0f0f0;\n  border: 2px solid #ccc;\n  transition: transform 0.2s;\n  cursor: pointer;\n}\n\n.square:hover {\n  transform: scale(1.05);\n}\n\n.square.x {\n  color: #4b0082;\n}\n\n.square.o {\n  color: #ff3d00;\n}\n\n.square.winning {\n  background: linear-gradient(145deg, #90ee90, #32cd32);\n  animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.07); }\n  100% { transform: scale(1); }\n}\n\n.status {\n  font-size: 1.3rem;\n  margin: 10px 0;\n  font-weight: bold;\n}\n\n.scores {\n  display: flex;\n  justify-content: space-around;\n  margin: 10px 0;\n  font-size: 1.1rem;\n}\n\n.controls button {\n  padding: 10px 20px;\n  border-radius: 20px;\n  font-weight: bold;\n  border: none;\n  margin: 5px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.3);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.play-again {\n  background: #673ab7;\n  color: white;\n}\n\n.new-game {\n  background: #2196f3;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
